module.exports = __webpack_public_path__ + "media/promo/lum2021/images/top-48d7d1603d44c884f85d9f02bd61f10d.jpg";